import { mapActions } from 'vuex'
import types from '../store/types'

const snackBar = {
    methods: {
        ...mapActions({
            _showSnackBar: types.snackBar.actions.show
        }),
        showSnackBar (text, color = 'selvyBlue') {
            this._showSnackBar({ text, color })
        }
    }
}

export default snackBar

